import React from 'react';
import { Modal, Input, Form, Select, Row, Col } from 'antd';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    idCultivo: values.idCultivo === undefined ? 0 : values.idCultivo.key == undefined ? 0 : values.idCultivo.key,
                    codigoReferencia: values.codigoReferencia

                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        var title = "";

        if (this.props.formValues.activeKey === "1")
            title = "Cultivo";
        if (this.props.formValues.activeKey === "2")
            title = "Etapa Fenológica";

        return (
            <Modal
                title={
                    this.props.formValues.id === 0 ? `Registrar ${title}` : `Modificar ${title}`
                } visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Codigo Referencia">
                                {getFieldDecorator('codigoReferencia', {
                                    initialValue: this.props.formValues.codigoReferencia,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar codigo"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    {this.props.formValues.activeKey == "2" ?
                        <Row gutter={16}>
                            <Col className="gutter-row" span={24}>
                                <Form.Item label="Cultivo">
                                    {getFieldDecorator('idCultivo', {
                                        initialValue: this.props.formValues.idCultivo > 0 ?
                                            { key: this.props.formValues.idCultivo } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione cultivo"}
                                            optionFilterProp="children"
                                        >
                                            {this.props.formValues.cultivos.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        : null
                    }
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)